import { render } from "./AdminArticles.vue?vue&type=template&id=41c44d0a"
import script from "./AdminArticles.vue?vue&type=script&lang=js"
export * from "./AdminArticles.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__